import { render } from "./FluidItem.vue?vue&type=template&id=566d5897&scoped=true"
import script from "./FluidItem.vue?vue&type=script&lang=js"
export * from "./FluidItem.vue?vue&type=script&lang=js"

import "./FluidItem.vue?vue&type=style&index=0&id=566d5897&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-566d5897"

export default script